import { useEffect, useMemo, useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useWindowEventListener from "./utils/useEventListner";
import querystring from "query-string";

function goToLogin({ navigate, next }) {
  navigate({
    pathname: "/login",
    search: `?${querystring.stringify(next)}`,
  });
}

function getPathForNext(location) {
  if (location.pathname === "/" || location.pathname === "/login") {
    return "/map/";
  }
  return location.pathname;
}
export default function useRouterController() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useMemo(() => window.localStorage.getItem("token"), []);
  const next = useMemo(() => ({ next: `${getPathForNext(location)}${location.search}` }), [
    location,
  ]);
  const [redirectDone, setRedirectDone] = useState(false);

  const handleApiResponse401 = useCallback(
    ({ detail }) => {
      if (location.pathname !== "/login") {
        goToLogin({ navigate, next });
      }
    },
    [location.pathname, navigate, next]
  );

  useWindowEventListener("API_RESPONSE_401", handleApiResponse401);

  useEffect(() => {
    if (!token && location.pathname !== "/login") {
      goToLogin({ navigate, next });
    } else if (token && (location.pathname === "/login" || location.pathname === "/")) {
      navigate({ pathname: "/map", search: location.search });
    }
    setRedirectDone(true);
  }, []);
  return redirectDone;
}
